import tw, { styled } from 'twin.macro';
import { ImageElement } from '@kontent-ai/gatsby-components';

export const StyledLogo = styled.div`
  ${tw`shrink-0`}
`;

export const StyledLinkTitle = styled.span`
  ${tw`sr-only`}
`;

export const StyledLink = styled.a``;

export const StyledImage = styled(ImageElement)`
  ${tw`h-[30px] w-[92px] lg:w-[163px] lg:h-[53px]`}
`;
